// Minimal client-side helper to request a PDF from the backend
// The backend expects { html: "<html>...</html>" } in the body and returns
// application/pdf binary.

export const requestPDF = async (htmlContent, abortSignal) => {
  const res = await fetch(`https://vitaldev.vitalinsights.in/html_to_pdf`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ html: htmlContent }),
    signal: abortSignal,
  });

  if (!res.ok) throw new Error(`PDF API error ${res.status}`);
  return res.blob();
}; 
